import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import axios from 'axios';
import Cookies from "js-cookie";
import ValidateAutoCrawlStatus from './Components/Notifier/Notifier';
import HttpsRedirect from 'react-https-redirect';
import { BaseUrl, JsonConfig } from './Repository/BaseRepository';

const jwtToken = Cookies.get("jwt_token");
const tenantName = Cookies.get("tenant_name");
const email = Cookies.get("UserLogin")
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
axios.interceptors.request.use(
  (request) => {
    const secondToken = Cookies.get("jwt_token");
    if (jwtToken !== secondToken) {
      // console.log("Inside request")
      // Cookies.remove('jwt_token')
      // Cookies.remove('UserLogin')
      // Cookies.remove('first_name')
      // Cookies.remove('last_name')
      // Cookies.remove('Role')
      // window.location.href = "/";
    }
    return request

  },
  (error) => {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  (response) => {
    return response; // Pass successful responses
  },
  async (error) => {
    console.log('Error encountered:', error); // Log the entire error
    // console.log('Error response:', error.response);
    // console.log('Error config:', error.config);

    const originalRequest = error.config;
    const refreshToken = Cookies.get("jwt_token");
    // console.log('Refresh token:', refreshToken);

    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry &&
      refreshToken
    ) {
      // console.log("Inside if block");
      originalRequest._retry = true;

      try {
        const url = `${BaseUrl}Auth/refresh-token?email=${email}`;
        const res = await axios.post(url);
        // console.log("Refresh token response:", res);

        if (res.data.statusCode === 200) {
          const sample = JSON.parse(res.data.payload);
          Cookies.set("jwt_token", sample.Token);

          originalRequest.headers["Authorization"] = `Bearer ${sample.Token}`;
          return axios(originalRequest); // Retry original request
        }
      } catch (refreshError) {
        // console.error("Token refresh error:", refreshError);
        Cookies.remove("jwt_token");
        Cookies.remove("tenant_name")
        window.location.href = "/";
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error); // Reject all other errors
  }
);
ValidateAutoCrawlStatus();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HttpsRedirect>
      <App />
    </HttpsRedirect>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
